module.exports = __webpack_public_path__ + "img/logo_AmberHill.e64f794b.png";